import log from '@scrtracker/logging';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@blueprintjs/core';
import { Error } from '@hogwarts/ui-components-core';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

// https://reactjs.org/docs/error-boundaries.html
class ComponentErrorAlertBoundary extends React.Component {
  state = {
    visible: false,
  };
  static propTypes = {
    children: PropTypes.node,
    navigate: PropTypes.func.isRequired,
  };
  componentDidCatch(error, info) {
    Sentry.captureException(error);
    log.error('Error', error);
    log.debug(info);
    // Display fallback UI
    // You can also log the error to an error reporting service
    this.setState({
      visible: true,
      error,
      info,
    });
  }
  onDismiss = () => {
    this.setState({ visible: false });
  };
  render() {
    const { navigate } = this.props;
    const { visible } = this.state;
    return (
      <>
        {visible && (
          <Error
            title="Oops, Sorry. Something went wrong!"
            action={
              <Button onClick={() => navigate('/')} intent="PRIMARY">
                Dashboard
              </Button>
            }
          />
        )}
        {!visible && this.props.children}
      </>
    );
  }
}

const ComponentErrorAlert = (props) => {
  const navigate = useNavigate();
  return <ComponentErrorAlertBoundary {...props} navigate={navigate} />;
};

export default ComponentErrorAlert;
